import * as styles from './styles';

import colors from '../../theme/tokens/colors';

interface LoadingProps {
  fill?: string;
  className?: string;
}

const Loading = ({ fill, className }: LoadingProps) => {
  return (
    <svg
      data-testid='loading'
      className={className}
      viewBox='0 0 52 14'
      height='14px'
      width='52px'
    >
      <g
        stroke='none'
        strokeWidth='1'
        fill={fill || colors.primary.DEFAULT}
        fillRule='evenodd'
      >
        <circle
          className={`${styles.circle} ${styles.circleLoading}`}
          cx='7'
          cy='7'
          r='7'
        />
        <circle
          className={`${styles.circle} ${styles.circleLoading}`}
          cx='26'
          cy='7'
          r='7'
        />
        <circle
          className={`${styles.circle} ${styles.circleLoading}`}
          cx='45'
          cy='7'
          r='7'
        />
      </g>
    </svg>
  );
};

export default Loading;
